import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  emits: ['stopLoading'],
  setup(__props, { emit }) {


const iframe = ref();

onMounted(() => {
  iframe.value.style.height = window.innerHeight + 'px';
  emit('stopLoading');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("iframe", {
    ref_key: "iframe",
    ref: iframe,
    id: "frame",
    src: "https://liff.line.me/1657205388-XYJPpBdb?shopid=d4f78b09-568e-428a-aaff-3a4d4cc2b941",
    width: "100%",
    height: "100%",
    scrolling: "no"
  }, null, 512))
}
}

})